/**
 * Daily worklog hour caps per user, shared by the workbook save-time rules
 * and the popup forms so both paths enforce the same business limits.
 *
 * Business model:
 *  - A day allows up to DAILY_BASE_HOURS_CAP (12) total hours (normal + extra).
 *  - An authorization row can raise that day's total via daily_limit_hours
 *    ("Tope jornada"), never above ABSOLUTE_DAILY_HOURS_LIMIT (24).
 *  - Marked extra hours are validated separately against the authorized extra
 *    hours of the day (authorization sheet total_hours), which cap at
 *    MAX_AUTHORIZED_HOURS_PER_DAY per user per day.
 */

export const DAILY_BASE_HOURS_CAP = 12
export const ABSOLUTE_DAILY_HOURS_LIMIT = 24
export const MAX_AUTHORIZED_HOURS_PER_DAY = 4

export interface DailyHourCaps {
  /** Máximo de horas totales del día (normales + extra). */
  totalCap: number
}

export function computeDailyCaps (dailyLimitHours?: number | null): DailyHourCaps {
  const limit = Number.isFinite(dailyLimitHours as number) ? Number(dailyLimitHours) : 0
  return {
    totalCap: Math.min(
      Math.max(limit, DAILY_BASE_HOURS_CAP),
      ABSOLUTE_DAILY_HOURS_LIMIT
    ),
  }
}
